export default __webpack_public_path__ + "05e74a4863251d98671a792c267b0cf4.png";